export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const SAVE_USER = 'SAVE_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const IS_USER_LOGGING_OUT = 'IS_USER_LOGGING_OUT'

export const state = {
  user: null,
  token: null,
  loggingOut: false
}

export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => state.user !== null,
  loggingOut: state => state.loggingOut
}

export const mutations = {
  [SAVE_TOKEN] (state, token) {
    state.token = token
  },

  [FETCH_USER_SUCCESS] (state, user) {
    state.user = user
  },

  [FETCH_USER_FAILURE] (state) {
    state.user = null
  },

  [LOGOUT] (state) {
    state.user = null
    state.token = null
    state.loggingOut = false
  },

  [IS_USER_LOGGING_OUT] (state, trueOrFalse) {
    state.loggingOut = trueOrFalse
  }
}

export const actions = {
  async saveToken ({ commit }, token) {
    commit(SAVE_TOKEN, token)
  },

  async fetchUserSuccess ({ commit }, user) {
    commit(FETCH_USER_SUCCESS, user)
  },

  async fetchUserFailure ({ commit }) {
    commit(FETCH_USER_FAILURE)
  },

  async logout ({ commit }) {
    commit(LOGOUT)
  },

  async isUserLoggingOut ({ commit }, trueOrFalse) {
    commit(IS_USER_LOGGING_OUT, trueOrFalse)
  }
}
